import { render } from "./campaign.vue?vue&type=template&id=cbb4461a"
import script from "./campaign.vue?vue&type=script&lang=js"
export * from "./campaign.vue?vue&type=script&lang=js"

import "./campaign.vue?vue&type=style&index=0&id=cbb4461a&lang=css"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-waha\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__